<template>
	<div class="header">
		<div class="select-container">
			<img :src="lang == 'pt' ? require('@/assets/img/br.png') : require('@/assets/img/en.png')"/>
			<select v-model="lang">
				<option value="pt">
					Português
				</option>
				<option value="en">
					
					English
				</option>
			</select>
		</div>
		
	</div>
</template>
<script>
export default{
	name: 'Header',
	watch:{
		lang: function(newOne, oldOne){
			console.log(newOne)
			localStorage.setItem('sqLocale', newOne)
			this.$i18n.locale = newOne
		}
	},
	data(){
		return {
			lang: 'en'
		}
	},
	mounted(){
		let currentVal = localStorage.getItem('sqLocale') 
		
		if(currentVal != "null" && currentVal != null){
			this.lang = currentVal
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/Header.vue